import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="create-product-listing-form"
export default class extends Controller {
  static outlets = ["polaris-button"];

  disableAllButtons(event) {
    this.formButtonOutlets.forEach((outlet) => {
      if (!outlet.element.disabled) {
        outlet.disableWithoutLoader(event);
      }
    });
  }

  enableAllButtons(event) {
    this.formButtonOutlets.forEach((outlet) => {
      if (outlet.element.disabled) {
        outlet.enable();
      }
    });
  }

  get formButtonOutlets() {
    return this.polarisButtonOutlets.filter((outlet) =>
      this.element.contains(outlet.element),
    );
  }
}
